import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { IdentityService } from '../identity.service';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  private readonly router = inject(Router);
  private readonly identity = inject(IdentityService);
  private readonly message = inject(MessageService);
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const clonedRequest = req.clone( {
      headers: req.headers.set( 'X-Requested-With', 'XMLHttpRequest'),
      withCredentials:true
    });
    
    return next.handle(clonedRequest).pipe ( 
      tap( {
        next: () => {},
        error: (err) => {
          if ( err instanceof HttpErrorResponse) {
            if ((err.status != 401) && (err.status != 403)) {
              return;
            }
    
            let detail = 'Non si dispone dei permessi per eseguire l\'operazione richiesta';
            let severity = 'error';
    
            if ( err.status == 401) {
              if (this.identity.isExpired()){
                this.identity.logout();
                this.router.navigateByUrl('/login?returnUrl=/');
                detail = 'Sessione di lavoro scaduta, tentativo di nuovo accesso in corso... ';
                severity = 'info';                
              }
            }
    
            this.message.add({
              severity: severity,
              summary: 'Attenzione',
              detail: detail
            });
          }
        }
      })
    );

  }
}
